import z from 'zod';

import { membershipFormSchema } from 'src/features/membership/formSchema';
import { validationMessagesMap } from 'src/utils/messages';

export type ExitFromParkingFormSchemaValues = z.infer<typeof exitFromParkingFormSchema>;
export const exitFromParkingFormSchema = z.object({
    exit_gateway: z.string().nonempty(),
    open_gateway: z.boolean(),
});

export type ConvertActiveStayToMembershipFormSchemaValues = z.infer<typeof convertActiveStayToMembershipFormSchema>;
export const convertActiveStayToMembershipFormSchema = membershipFormSchema.extend({
    active_stay: z.string(),
    is_validated: z.boolean(),
});

export type ChangeActiveStayPricingPlanFormSchemaValues = z.infer<typeof changeActiveStayPricingPlanFormSchema>;
export const changeActiveStayPricingPlanFormSchema = z
    .object({
        validation_type: z.string().nullish(),
        pricing_plan_identity: z.string().nullish(),
    })
    .superRefine((data, ctx) => {
        if (data.validation_type || data.pricing_plan_identity) return;

        ctx.addIssue({
            code: 'custom',
            message: validationMessagesMap.validationErrorRequired,
            path: ['validation_type'],
        });
        ctx.addIssue({
            code: 'custom',
            message: validationMessagesMap.validationErrorRequired,
            path: ['pricing_plan_identity'],
        });
    });